<template>
  <div><textarea ref="area"></textarea></div>
</template>

<script>
import SimpleMDE from "simplemde"
/* eslint-disable vue/require-prop-types */
export default {
  name: "Simplemde",
  props: ["value", "uniqueId"],
  watch: {
    // Setup a watch to track changes,
    // and only update when changes are made
    value(newVal) {
      if (newVal !== this.mde.value()) {
        this.mde.value(newVal)
      }
    },
  },
  mounted() {
    this.mde = new SimpleMDE({
      element: this.$refs.area, // Tie SimpleMDE to your textarea
      // Set your SimpleMDE configuration here
      // e.g. remove the status bar (status: false), customise the
      // toolbar (toolbar: ["bold", "italic", "heading"]) or similar
    })
    this.mde.value(this.value)
    const self = this
    this.mde.codemirror.on("change", () => {
      // Catch on change events
      self.$emit("input", self.mde.value())
    })
  },
  beforeDestroy() {
    // Clean up when the component gets destroyed
    this.mde.toTextArea()
  },
}
</script>

<style lang="scss" scoped></style>
